import type { DescriptionsProps } from "antd";
import { Descriptions, Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { getAssignedDataGroup } from "../../../../core/router/auth";
import { useAboutLoadQuery } from "../services/AboutApi";

type Props = {
    open: boolean;
    onClose: () => void;
};

export const AboutModal = ({ open, onClose }: Props) => {
    const { t } = useTranslation();
    const dataGroup = getAssignedDataGroup();
    const { data, isLoading } = useAboutLoadQuery(undefined, { skip: !open || !dataGroup?.code });

    const items: DescriptionsProps["items"] = [
        {
            key: "frontendVersion",
            label: t("about.frontendVersion"),
            children: APP_INFO.VERSION,
        },
        ...(data
            ? [
                  {
                      key: "backendVersion",
                      label: t("about.backendVersion"),
                      children: data.beVersion,
                  },
                  {
                      key: "formConfigName",
                      label: t("about.formConfigName"),
                      children: data.formConfigName,
                  },
                  ...(data.xsdVersion ? [{ key: "xsdVersion", label: t("about.xsdVersion"), children: data.xsdVersion }] : []),
                  {
                      key: "buildTimestamp",
                      label: t("about.buildTimestamp"),
                      children: data.buildTimestamp,
                  },
              ]
            : []),
    ];

    return (
        <Modal open={open} onCancel={onClose} title={t("about.title")} footer={null} closable width={500}>
            <Spin spinning={isLoading}>
                <Descriptions column={1} bordered size="small" items={items} style={{ minHeight: 80 }} />
            </Spin>
        </Modal>
    );
};
